<template>
<div class="panelNagusia">
  <div class="ui breadcrumb">
    <a class="section" v-on:click="goTo('/dashboard')">Home</a>
    <i class="right angle icon divider"></i>
    <a class="section" v-on:click="goTo('/apms')">Taquillas</a>
    <i class="right angle icon divider"></i>
    <a class="active section">Paquetes</a>
  </div>
  <h1 v-if="apmName" class="ui header"><img class="ui image" src="../../assets/apm.png" ><div class="content">{{ apmName }}</div></h1>
  <button class="ui basic button rightButton" v-on:click="goTo('/apms')">
    <i class="long arrow alternate left icon"></i>Atras
  </button>
  <div v-if="!rows" class="ui active centered inline loader"></div>
  <div v-if="rows" class="ui stackable one column divided grid container">
    <div class="row">
      <div class="column">
        <b>Total: {{ countInApt }}/{{ totalSlotApm }} </b>
        <h4 class="ui dividing header">Paquetes en la taquilla</h4>
        <vue-good-table
          :columns="columns"
          :rows="rows"
          :lineNumbers="true"
          :search-options="{
                enabled: true,
                trigger: 'enter',
                placeholder: 'Buscar en la tabla',
                }"
          :pagination-options="{
                perPage: 50,
                enabled: true,
                mode: 'pages'
                }"
          :sort-options="{
                enabled: true,
                initialSortBy: {field: 'lastUpdate', type: 'asc'}
                }"
          @on-row-click="parcelInfo"
            styleClass="vgt-table striped condensed bordered"
          >
        </vue-good-table>
      </div>
      <div class="column">
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'Parcels',
  props: ['id'],
  data() {
    return {
      apmName: null,
      role: null,
      totalSlotApm: 0,
      countInApt: 0,
      columns: [{
          label: 'Cliente',
          field: 'from',
        },
        {
          label: 'Teléfono',
          field: 'phone',
          type: 'number',
        },
        {
          label: 'Barcode',
          field: 'barcode',
        },
        {
          label: 'Refcode',
          field: 'refcode',
        },
        {
          label: 'Estado',
          field: 'status',
        },
        {
          label: 'Ult. Actualización',
          field: 'lastUpdate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
          dateOutputFormat: 'yyyy-MM-dd HH:mm:ss',
        }
      ],
      rows: null,
    }

  },
  created() {
    this.role = JSON.parse(localStorage.admin).role;
    this.getApmInfo()
  },
  methods: {
    getApmInfo() {
      hapiickApi().post('/v2/apms/shipments', {
        admin_id: JSON.parse(localStorage.admin).id,
        apm_id: this.id
      })
      .then(request => this.updateTable(request))
      .catch((request) => console.log('error getting parcels:' + request))
    },
    updateTable(req) {
      this.rows = []
      let parcels = []
      const { data } = {... req.data} 
      parcels = data.parcels

      this.apmName = data.name

      if (data.total_slots_apm) {
        this.totalSlotApm = data.total_slots_apm
      }
      this.countInApt = (parcels) ? parcels.length : this.countInApt

      for (const i in parcels) {
        let element = parcels[i]
        this.rows.push({
          'from': element.from,
          'phone': element.phone,
          'barcode': element.barcode,
          'refcode': element.refcode,
          'destination': element.destination,
          'status': element.status,
          'lastUpdate': element.lastUpdate,
          'id': element.id
        })
      }
    },
    goTo(where) {
      this.$router.push(where)
    },
    parcelInfo(params) {
      if (this.role == 'localAdmin') {
        this.goTo('/local/parcels/info/'+params.row.id)
      } else if (this.role == 'shophapiickPoint') {
        this.goTo('/history/parcel/'+params.row.from+'/'+params.row.id)
      } else {
        this.goTo('/parcels_v2/info/'+params.row.from+'/'+params.row.id)
      }
      
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Apms/Parcels.vue